export default "/static/dashboard/build/app/img/v2/9a954eb0294e6edcc6df8a7cad4ed885.png";